export class PackageDetails {
  productID: number;
  productName: string;
  productCategory: string;
  productType: string;
  packageDate: Date;
  packageFilename: string;
  packageSize: number;
}
